import apiBase from './ApiBase'

class ApiService {
  getAirportDetails = icao => apiBase.get('/api/LibraryDetails/airport/details/' + icao)
  getCityDetails = (countryCode, cityName, icao) => apiBase.get('/api/LibraryDetails/' + countryCode + '/' + cityName + '?airportICAOCode=' + icao)
  getCountryDetails = countryCode => apiBase.get('/api/LibraryDetails/' + countryCode)
  getCountriesWeaponaryData = () => apiBase.get('/api/GetAllCountries/')
  getCityRiskRatings = () => apiBase.get('/GetCityRiskRatings')
}

const SecurityCMSAPIService = new ApiService()

export default SecurityCMSAPIService